import React from 'react';
import { useTranslation } from 'react-i18next';
import ContentPage from 'src/components/ContentPage/ContentPage';
import { getSIVAYearList } from '../utils/getYearList';
import ReportingLinkList from 'src/features/siva/reporting/components/ReportingLinkList/ReportingLinkList';

const SivaAdminBudgetPage: React.FC = () => {
  const { t: tCommon } = useTranslation();
  const { t: tPageTitles } = useTranslation('pageTitles');
  const years = getSIVAYearList();

  return (
    <ContentPage
      title={tCommon('budget')}
      documentTitle={`${tCommon('budget')} - ${tPageTitles('sivaReporting')}`}
    >
      <ReportingLinkList
        items={years.map((year) => ({
          to: year.toString(),
          title: `${tCommon('budget')} ${year.toString()}`,
        }))}
      />
    </ContentPage>
  );
};

export default SivaAdminBudgetPage;
